// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import TimeGrid from './data'

export default function TimeGridFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/TimeGrid">
      <TimeGrid {...props}>
        {children}
      </TimeGrid>
    </Flow>
  )
}
